var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 251,
    viewBox: "0 0 601 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M677.829 -17.9721L641.39 172.498C555.644 142.444 468.413 120.63 388.405 153.846C351.777 169.052 317.893 195.417 282.049 214.003C194.154 259.616 96.2237 257.379 0.46371 230.596C-36.884 220.163 -74.5882 205.993 -111.498 208.527C-114.74 208.747 -118.007 209.127 -121.249 209.74L-43.1079 -148.957L677.829 -17.9721Z",
    fill: "#F0FBFA",
    stroke: "#F0FBFA",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.0fd67caf.svg";
export { ForwardRef as ReactComponent };